import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

// crypto.randomUUID is unavailable in insecure contexts (e.g. LAN dev over http).
export const uid = () =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export function formatBytes(bytes: number, decimals = 1) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** i).toFixed(i ? decimals : 0)} ${units[i]}`;
}

export function formatDuration(ms: number) {
  const total = Math.floor(ms / 1000);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}

export function randomDeviceName() {
  const a = ["Swift", "Bright", "Quiet", "Clever", "Sunny", "Mellow"];
  const b = ["Panda", "Falcon", "Otter", "Koala", "Robin", "Fox"];
  const tag = uid().replaceAll("-", "").slice(-6).toUpperCase();
  return `${a[Math.floor(Math.random() * a.length)]} ${b[Math.floor(Math.random() * b.length)]} ${tag}`;
}
